module.exports = __webpack_public_path__ + "img/colegio-modelo.c3a4e724.jpg";